export default {
    EXCHANGE_PERCENT : 'EXCHANGE_PERCENT'
}